import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {OrderSuccessPageService_GetDeliveriesTimeDiffLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/order_success_page/v1/service.grpc.lazy';
import {GetDeliveriesTimeDiffRequest_Package} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/order_success_page/v1/service.types';

export const useGetDeliveriesTimeDiffRequest = (
  deliveryTrackerPackages: GetDeliveriesTimeDiffRequest_Package[],
) => {
  return useGrpcRequest(
    OrderSuccessPageService_GetDeliveriesTimeDiffLazy,
    {packages: deliveryTrackerPackages},
    {disabled: !deliveryTrackerPackages.length},
  );
};
